export function isPrint() {
  if (typeof window === 'undefined') return false
  return window.location?.hash === '#print'
}
